
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { OnlineModule } from '@/store/modules/online'
import { OnlineService } from '@/services'
import OrderTable from '../components/order_table/index.vue'

@Component({
    name: 'media-write',
    components: {
        FullLoading,
        ScrollTo,
        OrderTable
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType

    private query = ''
    private dateQuery = ''
    private curType = ''
    private curStatus = ''
    private recordList: any[] = []
    private typeOptions = []
    private pageSize = 50
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true

    get statusOptions() {
        return OnlineModule.orderStates
    }

    async mounted() {
        await Promise.all([
            this.getOrderTypes(),
            OnlineModule.getOrderStates()
        ])
        // getOrderList 不要放到 Promise.all 里面，因为有先后顺序
        await this.getOrderList()
        this.isLoading = false
    }
    onSearch() {
        this.pageIndex = 1
        this.getOrderList()
    }
    onReset() {
        // 日期选择器 value
        this.dateQuery = ''
        // 输入框 value
        this.query = ''
        // 协助类型
        this.curType = ''
        // 协助状态
        this.curStatus = ''
    }
    onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getOrderList)
    }
    // 获取协助类型
    async getOrderTypes() {
        const params = { is_reporter: 1 }
        const result = await OnlineService.getOrderType(params)
        if (result.status === 200) {
            this.typeOptions = result.data
        }
    }
    // 获取协助列表
    async getOrderList() {
        const [start, end] = this.dateQuery || []
        const params = {
            is_reporter: 1,         // 媒体人
            id: this.query,
            start_at: start,
            end: end,
            type_id: this.curType,
            status: this.curStatus,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await OnlineService.getOrderList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.recordList = this.addAttrs(result.data.list)
            return
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
    addAttrs(list: any[]) {
        // 额外增加属性，用于更改状态失败后，恢复之前的状态
        return list.map(n => ({
            ...n,
            cstatus: { ...n.status },
            puser: { ...n.paoding_user }
        }))
    }
}
